import axios, { post }  from 'axios';


const base = () => {
  return axios.create({
    baseURL: '/bom_quotes/',
  })
}

export const doUploadFile = async (bom_file, token) => {
  const formData = new FormData();
  formData.append('bom_file', bom_file);
  formData.append('authenticity_token', token);

  try {
    return (await base().post('', formData)).data;
  } catch (err) {
    throw err
  }
}

export const doQuoteBom = async (itemId, bomId, bomParameters, token) => {
  var bom_parameters = bomParameters.bom_parameters;
  var bom_parameters_obj = {};

  for (let i = 0; i < bom_parameters.length; i++) {
    bom_parameters_obj[i] = bom_parameters[i]
  }

  const body = {
    bom_id: bomId,
    variant_id: itemId,
    header: bomParameters.header,
    first_row: bomParameters.first_row,
    board_qtys: bomParameters.quantities.join(","),
    bom_parameters: bom_parameters_obj,
    authenticity_token: token,
  }
  try {
    return (await base().post('quote', body)).data;
  } catch (err) {
    throw err
  }
}

export const doSaveBom = async (bomQuoteNumber, quote, report, token) => {
  var newquote = quote;
  newquote = {filename : newquote.filename,
              quantities: newquote.quantities,
              report: report,
              offers: newquote.offers,
              totals: newquote.totals,}

  
  const body = {
    quote: newquote,
    authenticity_token: token,
  }

  try {
    return (await axios.put('/bom_quotes/' + bomQuoteNumber, body)).data;
  } catch (err) {
    throw err
  }
}

export const doSearchPart = async (mpn) => {
  try {
    return (await base().get('search_part?keyword=' + mpn)).data;
  } catch (err) {
    throw err
  }
}

export const doSelectBomFile = async (bom_file, bundle_number) => {
  try {
    return (await base().get('asociate_bom_file?bundle_number=' + bundle_number + '&bom_file=' + bom_file)).data;
  } catch (err) {
    throw err
  }
};
